import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AppConfig } from './app.config';
import { initializer } from './core/utils/app-init';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { MaterialModule } from './core/modules/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { GuardComponent } from './core/security/guard/guard.component';
import { AuthExpiredInterceptor } from './core/security/auth-expired-interceptor';
import { AuthInterceptor } from './core/security/auth-interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SefazAlertService } from './shared/sefaz/sefaz-alert.service';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ConsultaOmissaoModule } from './modules/emitir-relatorio/emitir-relatorios.module';
import { HighlightModule, HIGHLIGHT_OPTIONS  } from 'ngx-highlightjs';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { LoadPermissionService } from './core/security/load-permission-service';
import { ExtratoProcessamentoEfdModule } from './modules/extrato-processamento-efd/extrato-processamento-efd.module';
import { ValidarExtratoModule } from './modules/validar-extrato/validar-extrato.module';

registerLocaleData(localePt);  

function loadPermissions(loadPermissionService: LoadPermissionService, ngxPermissionsService: NgxPermissionsService) {
  return () => loadPermissionService.loadPermissions().then((permissions) => {
    ngxPermissionsService.loadPermissions(permissions);
    return true;
  });
}

const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
    },
    vertical: {
      position: 'top',
    },
  },
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: false,
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 3,
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease',
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
    },
  },
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    FontAwesomeModule,
    FlexLayoutModule,
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,
    HttpClientJsonpModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    ConsultaOmissaoModule,
    NgbModule,
    InfiniteScrollModule,
    NgxWebstorageModule.forRoot(),
    NotifierModule.withConfig(customNotifierOptions),
    HighlightModule,
    BreadcrumbModule,
    NgxPermissionsModule.forRoot(),
    ExtratoProcessamentoEfdModule,
    ValidarExtratoModule
  ],
  providers: [
    LoadPermissionService,
    SefazAlertService,
    AppConfig,
    GuardComponent,
    { provide: LOCALE_ID, useValue: 'pt' },
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      multi: true,
      deps: [AppConfig],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true,
    },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        fullLibraryLoader: () => import('highlight.js'),
      }
    },
    {
      provide: APP_INITIALIZER,
      useFactory: loadPermissions,
      multi: true,
      deps: [LoadPermissionService, NgxPermissionsService],
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
